export enum SellerCategories {
  FURNITURE = 'furniture',
  TOOLS = 'tools'
}
